import React from 'react';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';

import Base from './Base';

const useStyles = makeStyles(() => ({
  bold: {
    fontWeight: 800,
  },
}))

function EjectionGameEvent({event, teams, players, periods}) {
  const classes = useStyles();
  const period = periods[event.period].name;
  const player = players[event.player];
  const team = teams[player.team].id;

  return (
    <Base
      time={event.second}
      period={period}
      team={team}
      type="Ejection"
    >
      <Typography variant="body2">
        <span className={classes.bold}>{player.name}</span>
        {' '}is ejected from the game
      </Typography>
    </Base>
  )
}

export default EjectionGameEvent;
